import { BusinessDomainEntityFilter } from '@ipen-portal/ipen-entity-model';
import { useGetEntitiesByFilter } from '@ipen-portal/plugin-common-react';

import { SelectFilter } from '../../../components/SelectFilter';
import { EntityDomainFilter } from '../utils/EntityDomainFilter';

const filterFactory = (domain: string) => new EntityDomainFilter(domain);

export const CoreProcessFilter = () => {
  const { value: domains } = useGetEntitiesByFilter(BusinessDomainEntityFilter);

  if (!domains) return null;

  return (
    <SelectFilter
      filterFactory={filterFactory}
      items={domains.map(domain => ({
        label: domain.metadata.title ?? domain.metadata.name,
        value: domain.metadata.name,
      }))}
      label="Core Process"
      mobile
      name="domain"
    />
  );
};
